module.exports = __webpack_public_path__ + "944e23e2808ca7239d4ab48b6e51f4bd.svg";